import { RouterProvider } from 'react-router-dom';
import { router } from 'src/sensors/router';
import { memo } from 'react';

export const AppSensors = memo(() => {
    const composeRouter = router();
    return <RouterProvider router={composeRouter}/>;
});
